module.exports = __webpack_public_path__ + "static/login_page_logo-b273257249f7aa1470c496a471d3a75e.png";